import { Component, ComponentFactoryResolver, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { WorkflowComponent, WorkflowInfo } from '../bean/workflowComponent';
import { JyExtendService } from '../new-flow/newFlow.service';
import { environment } from '@env/environment';
import { FormGroup } from '@angular/forms';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { CommonsService } from '@core/service/commons.service';
import { ProcessFlowService } from '@shared/components/process-flow/process-flow.service';
import { BrowseService } from '@shared/components/browse/browse.service';
import { ActivatedRoute } from '@angular/router';
import { ReuseTabService } from '@delon/abc';
import { BrowseConfig } from '@core/bean/browse-config';

@Component({
  selector: 'app-process-view',
  templateUrl: './process-view.component.html',
  styleUrls: ['../../jy-srm/srm-workflow/flow/flow.css']
})
export class ProcessViewComponent implements OnInit {
  process:any = {};
  dataId: any = null;
  forwarded: any = [];
  onOk;
  visible: boolean;
  darwerName =this.commons.translate('workflow.newWorkflow.processView');
  @ViewChild('child', { read: ViewContainerRef }) dmRoom: ViewContainerRef;
  opinionTitle = true;
  enclosure = false; // 流程附件tab
  flow = false;  // 流程附件tab
  fileList: any = [];  //附件列表
  url: any;
  imgNum: any = 0;
  imgIsVisible = false; //提交跳转流程图弹窗
  size = 'default'; //btn大小
  processFlow: any = {
    fileList: [],
    attachment: { id: null },
    assProcess: [],
    forwardId: [],
  };
  current:any ={};
  validateForm: FormGroup;
  isVisibles = false; //退回弹出层
  transferVisible = false; //转办弹出层
  loadingShow = false; //loading遮罩层
  editable;  //按钮文本是否可编辑
  historysEditable = false;  //新建情况下隐藏退回按钮
  forwardVisible = false;  //转发
  moreBtn = false;
  requestId:any = null;
  public iconName:any = 'anticon anticon-database';
  private component: WorkflowComponent;   //类型转换

  constructor(
    private JyExtendService: JyExtendService,
    private message: NzMessageService,
    private commons: CommonsService,
    private cfr: ComponentFactoryResolver,
    private processFlowService: ProcessFlowService,
    private modalService: NzModalService,
    private browseService: BrowseService,
    protected activatedRoute:ActivatedRoute,
    private reuseTabService:ReuseTabService
  ) { }

  ngOnInit() {
    let urlData = window.location.hash.split("?")[1].split("&");
    let workflowId = urlData[1].split("=")[1];
    let requestId = urlData[0].split("=")[1];
    this.requestId = requestId;
    let obj = {requestId:requestId};
    this.JyExtendService.validation(obj).subscribe(data=>{
      if(data == true){
        this.JyExtendService.current(obj).subscribe(data => {
          this.dataId = data['data'].dataId;
          this.process.workflowId = data['data'].workflowId;
          this.current = data['data'];
          this.backImg();
          let name = null;
          if(data['data'].editable == true){
            name = data['data'].workflowFormBase.formUrl; //流程模板路径
          }else{
            name = data['data'].workflowFormBase.readFormUrl;
          }
          this.createComponent(name);
          this.initData(data);
          const workflowInfo = new WorkflowInfo(this.process.workflowId, this.process.darwerName, this.editable,{});
          this.component.initData(this.dataId, workflowInfo);
        });
      }else{
        this.JyExtendService.validationFalse(obj).subscribe(data=>{
          this.dataId = data['data'].dataId;
          this.process.workflowId = data['data'].workflowId;
          this.current = data['data'];
          this.backImg();
          this.opinionTitle = false;
          let name = '';
          if(this.process.formUrl == undefined || this.process.formUrl == null){
            if(data['data'].editable == true){
              name = data['data'].workflowFormBase.formUrl; //流程模板路径
            }else{
              name = data['data'].workflowFormBase.readFormUrl;
            }
            this.createComponent(name);
            this.initData(data);
            const workflowInfo = new WorkflowInfo(this.process.workflowId, this.process.darwerName, this.editable,{});
            this.component.initData(this.dataId, workflowInfo);
          }else{
            name = this.process.formUrl;
            this.createComponent(name);
            const workflowInfo = new WorkflowInfo(this.process.workflowId, this.process.darwerName, this.editable,{});
            this.component.initData(this.dataId, workflowInfo);
            return
          }

        })
      }
    })
  }

  /**
   * 页面加载数据
   */
  initData(data) {
    if(data['data'].workflowFormBase.workflowNodeBase.workflowBase != null&&data['data'].workflowFormBase.workflowNodeBase.workflowBase != null){
      this.processFlow.linkFile = data['data'].workflowFormBase.workflowNodeBase.workflowBase.linkFile; //允许上传附件
      this.processFlow.linkFlow = data['data'].workflowFormBase.workflowNodeBase.workflowBase.linkFlow; //允许关联流程
      this.processFlow.confirm = data['data'].workflowFormBase.workflowNodeBase.workflowBase.confirm; //提交确认
      this.processFlow.transfer = data['data'].workflowFormBase.workflowNodeBase.workflowBase.transfer;  //转办按钮
      this.processFlow.showDiagram = data['data'].workflowFormBase.workflowNodeBase.workflowBase.showDiagram; //提交显示流程图
    }
    this.processFlow.nodeName = data['data'].workflowFormBase.workflowNodeBase.nodeName; //流程状态
    this.editable = data['data'].editable; //是否可编辑
    this.process.workflowId = data['data'].workflowId;
    this.processFlow.lastName = data['data'].lastOperator.userName;
    this.processFlow.detailBtn = data['data'].startNode; //删除按钮
    this.processFlow.requestId = data['data'].requestId; //requestId
    this.processFlow.forWard = data['data']['workflowFormBase'].workflowNodeBase.forward;  //转发按钮
    this.darwerName = data['data'].workflowFormBase.workflowNodeBase.workflowBase.workflowName;
    if(this.editable == true) {
      this.historysEditable = true;
    } else if(this.editable == false){
      this.processFlow.forWard = false;
      this.historysEditable = false;
    } //判断转办退回按钮
    if(this.processFlow.detailBtn == true || this.processFlow.transfer == true || this.processFlow.forWard == true){
      this.moreBtn = true;
    }else{
      this.moreBtn = false;
    }
  }

  /**
   * 创建动态组件
   * @param name
   */
  createComponent(name) {
    const factories = Array.from(this.cfr['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.componentName === name);
    const factory = this.cfr.resolveComponentFactory(factoryClass);
    this.dmRoom.clear();
    let component = this.dmRoom.createComponent(factory);
    this.component = <WorkflowComponent>component.instance;

  }

  /**
   * 关闭抽屉
   */
  close(): void {
    this.reuseTabService.replace('/dashboard');
    this.processFlow.fileListNum = null;
    this.processFlow.attachment = {};
    this.processFlow.result = [];
    this.enclosure = false;
    this.processFlow.opinionValue = null;
    this.processFlow.resultLength = null;
    this.processFlow.fileList = null;
    this.flow = false;
    this.imgIsVisible = false;
  }

  /**
   * 获取流程图
   */
  backImg() {
    this.imgNum++;
    //获取流程图
    if (this.processFlow.deploymentId == undefined) {
      // @ts-ignore
      this.processFlow.deploymentId = '';
    }
    let ImgObj = {deploymentId:this.processFlow.deploymentId,requestId:this.processFlow.requestId};
    let imgData = '';
    for (let key in ImgObj) {
      imgData += '&' + key + '=' + ImgObj[key];
    }
    imgData = imgData.slice(1);
    imgData = '?' + imgData + '&imgNum = ' + this.imgNum;
    this.processFlow.dataImg = environment.SERVER_URL + 'api/act/resource/read/' + imgData;
  }

  /**
   * 点击提交数据
   */
  commitData() {
    if (this.component.valid() == true) {
      let workData = this.component.formData();
      let allData = {
        param: workData,
        attachmentDto: this.processFlow.attachment,
        requestId: this.processFlow.requestId,
        workflowId:this.process.workflowId,
        workflowRequestLog: {
          remark: this.processFlow.opinionValue,
          workflowLinks: this.processFlow.assProcess,
        },
      };
      this.loadingShow = true;
      this.JyExtendService.addNewFlowData(allData).subscribe((data) => {
        this.loadingShow = false;
        if (data.status == 0) {
          this.processFlow.msgTiele = this.commons.translate('workflow.newWorkflow.Submission');
          this.commons.showSuccessMessage(this.processFlow.msgTiele);
          if(data.data != null && data.data.dataId != null){
            this.dataId = data.data.dataId;
          }
          this.backImg();
          if(this.processFlow.showDiagram == true){
            this.imgIsVisible = true;
          }else{
            this.imgIsVisible = false;
            this.close();
            this.processFlowService.Refresh(true);
          }
        }
        if (data.status == 1) {
          this.message.error(data.message, { nzDuration: 3000 });
        }
        this.loadingShow = false;
      });

    } else {
      return;
    }

  }

  /**
   * 保存
   */
  saveData() {
    if (this.component.valid() == true) {
      let workData = this.component.formData();
      let allData = {
        param: workData,
        attachmentDto: this.processFlow.attachment,
        requestId: this.processFlow.requestId,
        workflowId:this.process.workflowId,
        workflowRequestLog: {
          remark: this.processFlow.opinionValue,
          workflowLinks: this.processFlow.assProcess,
        },
      };
      this.loadingShow = true;
      this.JyExtendService.saveNewFlowData(allData).subscribe((data) => {
        if (data.status == 0) {
          this.commons.showSuccessMessage('msg.success.successfullySaved');
          this.loadingShow = false;
          this.close();
          this.processFlowService.Refresh(true);
        }
        if (data.status == 1) {
          this.processFlow.msgTiele = data.message;
          this.commons.showErrorMessage(this.processFlow.msgTiele);
          this.loadingShow = false;
        }
      });
    } else {
      return;
    }

  }


  /**
   * 退回节点弹出层
   */
  showModal(): void {
    this.isVisibles = true;
    this.historys();
  }

  handleOk(): void {
    this.isVisibles = false;
    this.RollbackAll();
  }

  handleCancel(): void {
    this.isVisibles = false;
  }

  /**
   * 获取回退节点
   */
  historys() {
    let histObj = {requestId:this.processFlow.requestId, workflowId: this.process.workflowId,dataId:this.dataId};
    this.JyExtendService.HistoryTask(histObj).subscribe((data) => {
      this.processFlow.historyData = data['data'];
    });
  }

  /**
   * 退回指定节点
   * @constructor
   */
  RollbackAll() {
    this.loadingShow = true;
    let rollObj = {
      workflowId: this.process.workflowId,
      requestId: this.processFlow.requestId,
      nodeId: this.processFlow.histoyValue,
      attachmentDto: this.processFlow.attachment,
      workflowRequestLog: {
        remark: this.processFlow.opinionValue,
        workflowLinks: this.processFlow.assProcess,
      },
    };
    this.JyExtendService.getRollback(rollObj).subscribe((data) => {
      if(data.status == 0){
        this.processFlow.msgTiele = this.commons.translate('workflow.newWorkflow.ReturnToSuccess');
        this.commons.showSuccessMessage(this.processFlow.msgTiele);
        this.close();
      }else{
        this.processFlow.msgTiele = data.message;
        this.commons.showErrorMessage(this.processFlow.msgTiele);
      }
    });
    this.loadingShow = false;
  }

  /**
   * 删除方法
   */
  deleteMethods() {
    let arr = [this.processFlow.requestId];
    this.JyExtendService.deleteBatchMethods(arr).subscribe((data) => {
      if(data == 'OK'){
        this.processFlow.msgTiele = this.commons.translate('workflow.monitorSet.deleteSuccess');
        this.commons.showSuccessMessage(this.processFlow.msgTiele);
        this.close();
        this.processFlowService.Refresh(true);
      }
    });

  }

  /**
   * 提交确认
   */
  showConfirm(): void {
    this.modalService.confirm({
      nzTitle: this.commons.translate('workflow.newWorkflow.confirmation'),
      nzContent: this.commons.translate('workflow.newWorkflow.submit'),
      nzOnOk: () => this.commitData(),
    });
  }

  /**
   * 判断提交是否弹出确认框
   */
  judgeCommit() {
    if (this.processFlow.confirm == true) {
      this.showConfirm();
    } else {
      this.commitData();
    }
  }

  /**
   * 获取用户名
   */
  getTransferUser() {
    this.JyExtendService.getUser().subscribe((data) => {
      this.processFlow.usersNAME = data;
    });
  }

  /*
  转办
  */
  Transfer() {
    let obj = { requestId: this.processFlow.requestId, userId: this.processFlow.selectUser };
    this.JyExtendService.Transfer(obj).subscribe((data) => {
      if (data['data'].status == 0) {
        this.processFlow.msgTiele = this.commons.translate('workflow.newWorkflow.successfulTransfer');
        this.commons.showSuccessMessage(this.processFlow.msgTiele);
        this.close();
        this.processFlowService.Refresh(true);
      } else if (data['data'].status == 1) {
        this.processFlow.msgTiele = data['data'].message;
        this.commons.showErrorMessage( this.processFlow.msgTiele);
      }
    });
  }

  /**
   * 转办弹窗
   */
  TransferShow() {
    this.transferVisible = true;
    this.getTransferUser();
  }

  /**
   * 关闭弹窗
   */
  hideTransfer() {
    this.transferVisible = false;
    this.forwardVisible = false;
    this.processFlow.forwardId = [];
    this.forwarded = [];
  }

  /**
   * 选择关联流程
   */
  conFig: BrowseConfig = new BrowseConfig('ProcessComponent');

  getProcess() {
    this.conFig.multiple = true;
    this.browseService.open(this.conFig,
      (result) => {
        let arr = [];
        result.forEach(v => {
          arr.push({
            workflowId: v.workflowId,
            requestId: v.requestId,
            title: v.title,
          });
        });
        this.processFlow.result = result;
        this.processFlow.assProcess = arr;
        this.processFlow.resultLength = this.processFlow.result.length;
      },
      () => {
      });
    this.enclosure = false;
    this.flow = true;
  }

  /**
   * 添加附件流程tab切换
   */
  enclosures() {
    this.enclosure = true;
    this.flow = false;
  }

  /**
   * 附件列表
   */
  changeFile(data) {
    this.fileList = data.fileList;
    let arr = [];
    if (data.type == 'success') {
      data.fileList.forEach(v => {
        arr.push({
          id: v.response.id,
          uid: v.uid,
        });
      });
    } else if (data.type == 'removed') {
      data.fileList.forEach(v => {
        arr.push({
          id: v.response.id,
          uid: v.uid,
        });
      });
    }
    this.processFlow.attachment.attachFile = arr;
    this.processFlow.fileListNum = data.fileList.length;
  }

  /**
   * 删除关联流程
   */
  deleteFlows(id) {
    this.processFlow.result.forEach(v => {
      if (v.workflowId == id) {
        let index = this.processFlow.result.indexOf(v);
        if (index > -1) {
          this.processFlow.result.splice(index, 1);
        }
      }
    });
    this.processFlow.assProcess.forEach(i => {
      if (i.workflowId == id) {
        let index = this.processFlow.assProcess.indexOf(i);
        if (index > -1) {
          this.processFlow.assProcess.splice(index, 1);
        }
      }
    });
    this.processFlow.resultLength = this.processFlow.result.length;
  }

  /**
   * 查看流程跳转
   */
  processSee(req,wk) {
    let url = '?requestId=' + req + '&workflowId=' + wk;
    window.open('/#/process' + url);
  }


  /**
   * 转发
   */
  forwardMethods() {
    this.forwardVisible = true;
  }

  /**
   * 获取转发人员
   */
  config: BrowseConfig = new BrowseConfig('PersonBrowseComponent');

  getPersonnel() {
    this.config.isEdit = true;
    this.config.multiple = true;
    this.browseService.open(this.config,
      (result) => {
        result.forEach(v => {
          this.processFlow.forwardId.push(v.id);
        });
        this.forwarded = result;
      },
      () => {
      });
  }

  /**
   * 转发人员选择变化
   */
  forwardChange(id) {
    this.processFlow.forwardId.forEach(v => {
      if (v == id) {
        let index = this.processFlow.forwardId.indexOf(v);
        if (index > -1) {
          this.processFlow.forwardId.splice(index, 1);
        }
      }
    });
  }

  /**
   * 转发提交
   */
  forwardSubmission() {
    let obj = { requestId: this.processFlow.requestId, userIds: this.processFlow.forwardId };
    this.JyExtendService.getForward(obj).subscribe(data => {
      if (data['data'].status == 0) {
        this.processFlow.msgTiele = this.commons.translate('workflow.newWorkflow.forwardSuccess');
        this.commons.showSuccessMessage( this.processFlow.msgTiele);
        this.hideTransfer();
        this.close();
        this.processFlowService.Refresh(true);
      }else{
        this.processFlow.msgTiele = data['data'].message;
        this.commons.showErrorMessage( this.processFlow.msgTiele);
      }
    });
  }


}
